import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import Storage from '@/amplify/storage';

import { uploadFileToS3 } from '@/service/s3Service';
import organizationService from '@/service/organizationService';
import { getUrlLinkCorporationDetails, initCorporationAndListUser } from '@/component/rootOrganization/EditOrganizationHandler';
import { getTicketById } from '@/service/ticketService';
import { resolveKBoardPromptTicket } from '@/component/common/handler/KBoardSystemPromptHandler';
import { v4 as uuidv4 } from 'uuid';
import trI18n from '@/common/utils/trI18n';

/**
 * Check a flag of limitValue is ON
 * @param {*} limitValue
 * @param {*} flagName
 * @returns {boolean}
 */
const isLimitValueFlagOn = (limitValue, flagName) => {
    return limitValue?.[flagName] === Constant.STATUS_SERVICE_PERMISSION.ON;
};

/**
 * Handle submit edit corporation
 * @param {*} API
 * @param {*} stateObj
 * @param {*} formData
 * @param {*} corporationDetail
 * @param {*} updator
 * @returns corporationDetail
 */
export const handleSubmitEditCorporation = async (
    API,
    stateObj,
    formData,
    corporationDetail,
    updator,
    setLincenseKey,
    setLicenseKeyDefault,
    lincenseKey,
    usingAIAuto,
    usingSDAuto,
    usingTelephoneAgent,
    usingFileTranslation,
    usingKBoard,
    systemPrompt,
    chatGPTModel,
    knn,
    minScore,
    setSystemPromptDefault,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    setSystemPrompt,
    setInputSystemPrompt,
    interatorSystemPrompt,
    setInteratorSystemPrompt,
    setInteratorSystemPromptDefault,
    setInputInteratorSystemPrompt,

    modelSettingList,
    setModelSettingList,
    modelSettingAddList,
    setModelSettingAddList,
    setModelSettingListRoot,
    usingMCPServer,
    kBoardSystemPrompt,
    usingKibanaAnalysis,
    usingMultiLanguage
) => {
    try {
        if (stateObj?.croppedImage?.image && stateObj?.logoFileName) {
            stateObj.croppedImage.name = stateObj.logoFileName;
        }
        
        let addModelSetting = modelSettingAddList.map(item => {
            let newData = {
                interatorSystemPrompt: item.interatorSystemPrompt.linkPrompt,
                model: item.model,
                systemPrompt: item.systemPrompt.linkPrompt,
            }
            return newData;
        })
        let updateModelSetting = modelSettingList.map(item => {
            let newData = {
                interatorSystemPrompt: item.interatorSystemPrompt.linkPrompt,
                model: item.model,
                systemPrompt: item.systemPrompt.linkPrompt,
                createdAt: item.createdAt
            }
            return newData;
        })

        const isUsingChatAIOn = formData?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON;
        // file translation depends on AI Auto
        const canUseFileTranslation = usingAIAuto && usingFileTranslation;
        // telephone agent depends on AI Auto
        const canUseTelephoneAgent = usingAIAuto && usingTelephoneAgent;

        const corporationSetting = {
            usingIpAddressRestrict: formData?.usingIpAddressRestrict,
            ipAddressRange: formData?.ipAddressRange,
            usingMultiAuth: formData?.usingMultiAuth,
            addModelSetting: addModelSetting,
            updateModelSetting: updateModelSetting,
            usingMCPServer: usingMCPServer ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingKibanaAnalysis: usingKibanaAnalysis ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF,
            kBoardSystemPrompt: kBoardSystemPrompt || '',
        }

        let editCorporationRequestDto = {
            id: corporationDetail.id,
            name: formData.corporationName,
            mail: formData.mailAdmin,
            owner: formData.selectedAdmin.id,
            tel: formData.telNumberCorporation ? formData.telNumberCorporation : '',
            usingChatAI: formData?.usingChatAI,
            updator: updator,
            usingAIAuto: usingAIAuto ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingSDAuto: usingSDAuto ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingTelephoneAgent: canUseTelephoneAgent
                ? Constant.STATUS_SERVICE_PERMISSION.ON
                : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingFileTranslation: canUseFileTranslation
                ? Constant.STATUS_SERVICE_PERMISSION.ON
                : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingKBoard: usingKBoard
                ? Constant.STATUS_SERVICE_PERMISSION.ON
                : Constant.STATUS_SERVICE_PERMISSION.OFF,
            usingMultiLanguage: usingMultiLanguage
                ? Constant.STATUS_SERVICE_PERMISSION.ON
                : Constant.STATUS_SERVICE_PERMISSION.OFF,
            systemPrompt: systemPrompt?.linkPrompt,
            interatorSystemPrompt: interatorSystemPrompt?.linkPrompt,
            corporationSetting: JSON.stringify(corporationSetting),
            chatGPTModel: chatGPTModel,
            knnValue: knn.value,
            minScore: minScore.value
        };

        // no function depending on AI can be sent as ON while AI is OFF
        if (!isUsingChatAIOn) {
            Constant.CHAT_AI_DEPENDENT_USING_FLAGS.forEach(flag => {
                editCorporationRequestDto[flag] = Constant.STATUS_SERVICE_PERMISSION.OFF;
            });
        }

        if (stateObj.croppedImage) {
            let logo = {
                image: `${corporationDetail.organizationDomain}/logo/logo` + new Date().getTime(),
                name: stateObj.croppedImage.name
            }
            
            await uploadLogoS3(stateObj.croppedImage, logo.image + '/' + logo.name);
            editCorporationRequestDto.logo = JSON.stringify(logo);
        } else {
            editCorporationRequestDto.logo = JSON.stringify({});
        }

        editCorporationRequestDto.lincenseKeyValue = formData.lincenseKeyValue || '';

        let editOrganizationRequestBody = { editCorporationRequestDto: editCorporationRequestDto };

        let resEditOrganization = await organizationService.editOrganization(
            API,
            editOrganizationRequestBody
        );
        let corporationSettingUpdate = Utils.convertJSONDataToObject(resEditOrganization.corporationSetting);
        let modelSettingListData = corporationSettingUpdate?.modelSettingList || []
        modelSettingListData = modelSettingListData.sort((a, b) => {
            return new Date(b?.createdAt) - new Date(a?.createdAt);
        });
        if (corporationSettingUpdate.isError) {
            setModelSettingList(corporationSettingUpdate.listModelSetting);
            setModelSettingAddList(corporationSettingUpdate.listAddModelSetting);
            
            return {
                isEditedSuccess: false,
                isErrorModelSetting: true
            };
        }

        setSystemPromptDefault(systemPrompt);
        setInteratorSystemPromptDefault(interatorSystemPrompt);
        setChatGPTModelDefault(chatGPTModel);
        setKnnDefault(knn);
        setMinScoreDefault(minScore);
        setLicenseKeyDefault(lincenseKey.value);
        let limitValue = Utils.convertJSONDataToObject(resEditOrganization.limitValue)
        let corporationDetailResult = { 
            ...corporationDetail, 
            corporationSetting: resEditOrganization?.corporationSetting,
            logoFileName: resEditOrganization.logoFileName ? resEditOrganization.logoFileName : corporationDetail.logoFileName 
        };
        setModelSettingList(modelSettingListData);
        setModelSettingAddList([])
        setModelSettingListRoot(modelSettingListData);
        // create corporation detail result
        
        let corporationLogo = Utils.getCloudFrontUrlForCorporationLogo({
            type: Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE,
            image: resEditOrganization.image,
            corporationId: corporationDetail.organizationDomain,
            corporationDetail: corporationDetailResult
        });
        
        corporationDetailResult.corporationName = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            resEditOrganization.name
        );
        corporationDetailResult.logoFileName = resEditOrganization.logoFileName;
        corporationDetailResult.image = resEditOrganization.image;
        corporationDetailResult.name = resEditOrganization.name;
        corporationDetailResult.corporationLogo = corporationLogo;
        corporationDetailResult.limitValue = limitValue;
        corporationDetailResult.mail = editCorporationRequestDto.mail;
        corporationDetailResult.owner = editCorporationRequestDto.owner;

        return {
            isEditedSuccess: true,
            corporationDetail : corporationDetailResult
        };
    } catch (err) {
        console.log('err editCorp >>>', err)
        if(!Utils.isEmptyObject(err) && !Utils.isEmptyArray(err.errors[0])) {
            if (
                [
                    'ApiError==MSG_AI_LICENSE_KEY_REQUIRED',
                    'ApiError==MSG_AI_LICENSE_KEY_INVALID',
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setLincenseKey(prev => ({
                    ...prev,
                    error: trI18n(`${errMsg.split("==")[1]}`)
                }))
            }
            if (
                [
                    'ApiError==MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN'
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setSystemPrompt(prev => ({
                    ...prev,
                    error: trI18n(`${errMsg.split("==")[1]}`)
                }))
                setInputSystemPrompt(systemPrompt?.linkPrompt);
            }
            if (
                [
                    'ApiError==MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR'
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setInteratorSystemPrompt(prev => ({
                    ...prev,
                    error: trI18n(`${errMsg.split("==")[1]}`)
                }))
                setInputInteratorSystemPrompt(interatorSystemPrompt?.linkPrompt);
            }

            return {
                isEditedSuccess: false,
                error: err.errors[0].message,
                corporationDetail
            };
        }
    }
};

const uploadLogoS3 = async (croppedImage, filePath) => {
    if (!croppedImage) return;
    if (croppedImage.file) {
        let fileUpload = { ...croppedImage };
        fileUpload.key = filePath;
        let uploadAvatar = await uploadFileToS3(filePath, fileUpload);
        if (!uploadAvatar) {
            return;
        }
    }
};

const getListGptModel = async () => {
    let data = []
    try {
        let CHAT_GPT_MODEL_URL = 'assets/listChatGptModel';
        const fileUrl = await Storage.get(CHAT_GPT_MODEL_URL, {
            level: 'public'
        });
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`Fetch failed with status ${response.status}`);
        }
        data = await response.text();
        data = Utils.convertJSONDataToObject(data);
    } catch (error) {
        console.error('Err getListChatGptModel:', error);
    }

    return data;
}

export const getInitCorporationAndListUser = async (argsAll) => {  
    try {
        argsAll.setIsLoading(true);

        const [apiResponse] = await Promise.all([
            initCorporationAndListUser(argsAll.corporationId),
        ]);

        
        let listGptModel = OpenAiUtil.getListChatGptModelFromCorpDetail(argsAll.corporationDetailAtom, true);
        if (Utils.isEmptyArray(listGptModel)) {
            listGptModel = await getListGptModel();
        }

        if (!apiResponse || Utils.isEmptyObject(apiResponse)) {
            return false;
        }
        if (apiResponse?.corporationData?.active === Constant.CORPORATION_ACTIVE.DELETED) {
            argsAll.closePanelTab({
                event: null,
                panelType: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
                panelId: argsAll.panelId,
                tabId: argsAll.tabId
            });
            return false;
        }
        if (!Utils.isEmptyArray(apiResponse.adminList)) {
            apiResponse.adminList = Utils.sortListByLabelDictionaryASC(
                apiResponse.adminList,
                'fullName'
            );
        }
        argsAll.setInitData(apiResponse);

        const checkAdminGuest = Utils.isGuestContractType(apiResponse.corporationData)
        argsAll.setIsAdminGuest(checkAdminGuest);

        argsAll.setAdminList(apiResponse.adminList);

        argsAll.setAdminName(apiResponse.ownerData.fullName);
        
        argsAll.setAdminMail(apiResponse.ownerData.mail);

        argsAll.setCorporationPhone(apiResponse.corporationData.tel);

        const getSubDomain = getUrlLinkCorporationDetails(apiResponse.corporationData);
        argsAll.setSubDomain(getSubDomain)

        /**
         * `chatAI`, `aiAuto`, `sdAuto`, `telephoneAgent`, `fileTranslation`, `kBoard` are the
         * permission flags granted by Root Org, the `using*` are the usage flags of this org.
         * A usage flag is only effective when its parent flags are ON, so the init state is
         * taken from DB and gated by the parent flags. This keeps the toggles from being
         * displayed as ON while they are disabled when data of an org is not consistent yet.
         */
        const limitValueOfCorp = apiResponse.corporationData.limitValue || {};
        const isChatAIPermissionOn = isLimitValueFlagOn(limitValueOfCorp, 'chatAI');
        const isUsingChatAIOn = isChatAIPermissionOn && isLimitValueFlagOn(limitValueOfCorp, 'usingChatAI');
        const isUsingAIAutoOn = isUsingChatAIOn && isLimitValueFlagOn(limitValueOfCorp, 'usingAIAuto');

        argsAll.setUsingChatAI(isUsingChatAIOn);

        argsAll.setUsingAIAuto(isUsingAIAutoOn);

        argsAll?.setUsingSDAuto &&
            argsAll.setUsingSDAuto(
                isUsingChatAIOn && isLimitValueFlagOn(limitValueOfCorp, 'usingSDAuto')
            );

        argsAll?.setUsingTelephoneAgent &&
            argsAll.setUsingTelephoneAgent(
                isUsingAIAutoOn && isLimitValueFlagOn(limitValueOfCorp, 'usingTelephoneAgent')
            );

        argsAll?.setUsingFileTranslation &&
            argsAll.setUsingFileTranslation(
                isUsingAIAutoOn &&
                    isLimitValueFlagOn(limitValueOfCorp, 'fileTranslation') &&
                    isLimitValueFlagOn(limitValueOfCorp, 'usingFileTranslation')
            );

        argsAll?.setUsingKBoard &&
            argsAll.setUsingKBoard(
                isUsingChatAIOn &&
                    isLimitValueFlagOn(limitValueOfCorp, 'kBoard') &&
                    isLimitValueFlagOn(limitValueOfCorp, 'usingKBoard')
            );

        // multiLanguage is independent from AI (no chatAI dependency).
        // usingMultiLanguage is only ON when Root granted permission AND org turned it on.
        argsAll?.setUsingMultiLanguage &&
            argsAll.setUsingMultiLanguage(
                isLimitValueFlagOn(limitValueOfCorp, 'multiLanguage') &&
                    isLimitValueFlagOn(limitValueOfCorp, 'usingMultiLanguage')
            );

        const systemPromptDetail = apiResponse.corporationData.limitValue?.systemPrompt
            ? apiResponse.corporationData.limitValue?.systemPrompt
            : {
                  value: '',
                  error: '',
                  linkPrompt: ''
              };
        if (!Utils.isEmptyString(systemPromptDetail?.linkPrompt)) {
            const systemPromptId = await Utils.getTicketIdByShareLink(systemPromptDetail?.linkPrompt);
            const ticketDetail = await getTicketById(null, systemPromptId)
            const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId)
            if (
                (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                    !formStatusOfTicket?.active ||
                    ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                    ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
                !Utils.isEmptyObject(ticketDetail)
            ) {
                systemPromptDetail.error = trI18n('MSG-CM-INVALID-LINK-PROMPT');
                systemPromptDetail.value = ''
            }
        }
        argsAll.setInputSystemPrompt(systemPromptDetail?.linkPrompt)
        argsAll.setSystemPrompt(systemPromptDetail);
        argsAll.setSystemPromptDefault(systemPromptDetail);

        const interatorSystemPromptDetail = apiResponse.corporationData.limitValue?.interatorSystemPrompt
            ? apiResponse.corporationData.limitValue?.interatorSystemPrompt
            : {
                  value: '',
                  error: '',
                  linkPrompt: ''
              };
        if (!Utils.isEmptyString(interatorSystemPromptDetail?.linkPrompt)) {
            const interatorSystemPromptId = interatorSystemPromptDetail?.linkPrompt
            ?.split('/')
            .pop();
            const ticketDetail = await getTicketById(null, interatorSystemPromptId);
            const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId);
            if (
                (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                    !formStatusOfTicket?.active ||
                    ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                    ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
                !Utils.isEmptyObject(ticketDetail)
            ) {
                interatorSystemPromptDetail.error = trI18n('MSG-CM-INVALID-LINK-PROMPT');
                interatorSystemPromptDetail.value = '';
            }
        }
        argsAll.setInputInteratorSystemPrompt(interatorSystemPromptDetail?.linkPrompt)
        argsAll.setInteratorSystemPrompt(interatorSystemPromptDetail);
        argsAll.setInteratorSystemPromptDefault(interatorSystemPromptDetail);

        if (argsAll.setKBoardPromptDetail) {
            const corporationSetting = Utils.convertJSONDataToObject(apiResponse.corporationData?.corporationSetting) || {};
            const savedKBoardLink = corporationSetting?.kBoardSystemPrompt || '';
            if (!Utils.isEmptyString(savedKBoardLink)) {
                argsAll.setKBoardSystemPromptLink(savedKBoardLink);
                const { isValid, ticketDetail } = await resolveKBoardPromptTicket(savedKBoardLink);
                if (isValid) {
                    argsAll.setKBoardPromptDetail(ticketDetail);
                    if (argsAll.setErrorKBoardSystemPrompt) argsAll.setErrorKBoardSystemPrompt('');
                } else if (!Utils.isEmptyObject(ticketDetail)) {
                    // Prompt bị soft delete hoặc save draft → giữ chip + hiển thị warning
                    argsAll.setKBoardPromptDetail(ticketDetail);
                    if (argsAll.setErrorKBoardSystemPrompt) argsAll.setErrorKBoardSystemPrompt(Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK);
                } else {
                    argsAll.setKBoardSystemPromptLink('');
                    argsAll.setKBoardPromptDetail({});
                    if (argsAll.setErrorKBoardSystemPrompt) argsAll.setErrorKBoardSystemPrompt('');
                }
            } else {
                argsAll.setKBoardSystemPromptLink('');
                argsAll.setKBoardPromptDetail({});
                if (argsAll.setErrorKBoardSystemPrompt) argsAll.setErrorKBoardSystemPrompt('');
            }
        }
        
        let dataSettingChatGPTModel = {
            chatGPTModel: apiResponse?.corporationData?.corporationSetting?.chatGPTModel
                ? apiResponse?.corporationData?.corporationSetting?.chatGPTModel
                : apiResponse?.corporationData?.limitValue.chatGPTModel,
            knnValue: apiResponse?.corporationData?.corporationSetting?.knnValue
                ? apiResponse?.corporationData?.corporationSetting?.knnValue
                : apiResponse?.corporationData?.limitValue.knnValue,
            minScore: apiResponse?.corporationData?.corporationSetting?.minScore
                ? apiResponse?.corporationData?.corporationSetting?.minScore
                : apiResponse?.corporationData?.limitValue.minScore
        };
        
        argsAll.setChatGPTModel(dataSettingChatGPTModel.chatGPTModel);
        argsAll.setChatGPTModelList(listGptModel);
        argsAll.setIsModelUnsupport(checkModelUnsupport(dataSettingChatGPTModel.chatGPTModel, listGptModel))
        argsAll.setKnn({
            value: dataSettingChatGPTModel.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
            error: ''
        })
        argsAll.setMinScore({
            value: dataSettingChatGPTModel.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
            error: ''
        })

        argsAll.setChatGPTModelDefault(dataSettingChatGPTModel.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
        argsAll.setKnnDefault({
            value: dataSettingChatGPTModel.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
            error: ''
        })
        argsAll.setMinScoreDefault({
            value: dataSettingChatGPTModel.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
            error: ''
        })
        
        argsAll.setImagePreview(argsAll.corporationDetailAtom.corporationLogo);
        argsAll.setLogoFileName(argsAll.corporationDetailAtom.logoFileName);
        argsAll.setOldLogoFileName(argsAll.corporationDetailAtom.logoFileName);
        
        argsAll.register('corporationName');
        argsAll.register('selectedAdmin');
        argsAll.register('mailAdmin');
        argsAll.register('telNumberCorporation');
        argsAll.register('usingChatAI');

        argsAll.setValue('corporationName', apiResponse.corporationData.name);
        argsAll.setValue('selectedAdmin', apiResponse.ownerData);
        argsAll.setValue('mailAdmin', apiResponse.ownerData.mail);
        argsAll.setValue('telNumberCorporation', apiResponse.corporationData.tel);
        argsAll.setValue('usingChatAI', isUsingChatAIOn ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF);

        argsAll.register('lincenseKeyValue');
        argsAll.setValue('lincenseKeyValue', apiResponse?.corporationData?.limitValue?.lincenseKeyValue);

        argsAll.setLincenseKeyPermission(
            apiResponse.corporationData.limitValue?.lincenseKeyPermission === Constant.STATUS_SERVICE_PERMISSION.ON
        );

        argsAll.setLincenseKey({
            value: apiResponse?.corporationData?.limitValue?.lincenseKeyValue,
            error: apiResponse?.corporationData?.limitValue?.lincenseKeyValid
                ? trI18n(`${apiResponse?.corporationData?.limitValue?.lincenseKeyValid}`)
                : ''
        });

        argsAll.setLicenseKeyDefault(apiResponse?.corporationData?.limitValue?.lincenseKeyValue);


        let modelSettingList = apiResponse?.corporationData?.corporationSetting?.modelSettingList;
        modelSettingList = createModelSettingListForOldCorp(modelSettingList, systemPromptDetail, interatorSystemPromptDetail, dataSettingChatGPTModel.chatGPTModel)
        argsAll.setModelSettingList(modelSettingList);
        argsAll.setModelSettingAddList([]);
        argsAll.setModelSettingListRoot(modelSettingList);

        argsAll.setUsingMCPServer(
            apiResponse.corporationData.corporationSetting?.usingMCPServer
                ? apiResponse.corporationData.corporationSetting?.usingMCPServer ===
                      Constant.STATUS_SERVICE_PERMISSION.ON
                : false
        );

        argsAll.setUsingKibanaAnalysis(
            apiResponse.corporationData.corporationSetting?.usingKibanaAnalysis
                ? apiResponse.corporationData.corporationSetting?.usingKibanaAnalysis ===
                      Constant.STATUS_SERVICE_PERMISSION.ON
                : false
        );
        return true;

    } catch (e) {
        console.log('get initCorp error >>>', e);
        return e;
    }
}

const createModelSettingListForOldCorp = (modelSettingList, systemPromptDetail, interatorSystemPromptDetail, chatGPTModel) => {
    if (!Utils.isEmptyArray(modelSettingList)) {
        let newModelSettingList = modelSettingList.map(item => ({
            ...item,
            id: uuidv4(),
        }));
        newModelSettingList = newModelSettingList.sort((a, b) => {
            return new Date(b?.createdAt) - new Date(a?.createdAt);
        });
        return newModelSettingList;
    }
    return [];
}

export const onLogoFileChange = (event, setLogoFileName, setInputImage, setOpenCrop) => {
    const file = event.target.files[0];
    if (file) {
        setLogoFileName(file.name);
        Utils.readFileAsArrayBuffer(file).then(reader => {
            const buffer = Buffer.from(reader.result);
            const imgBase64 = buffer.toString('base64');
            setInputImage(`data:${file.type};base64,${imgBase64}`);
            setOpenCrop(true);
            event.target.value = '';
        });
    }
};

export const handleCancelTab = (
    isEdited,
    setIsShowPopUpCancel,
    errors,
    errorImage
) => {
    if (
        isEdited &&
        Utils.isEmptyObject(errors) &&
        Utils.isEmptyString(errorImage) 
    ) {
        setIsShowPopUpCancel(true);
    }
};

export const handleCloseTab = (
    panelId,
    tabId,
    panelList,
    closePanelTab,
    setIsShowPopUpCloseTab
) => {
    let currentPanelInfo = Utils.getPanelInfo(panelId, panelList);
    if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
    closePanelTab({
        event: null,
        panelType: currentPanelInfo.type,
        panelId: panelId,
        tabId: tabId
    });
    setIsShowPopUpCloseTab(false);
}

export const checkModelUnsupport = (modelId, chatGPTModelListParams = []) => {
    let chatGPTModelList = Utils.isEmptyArray(chatGPTModelListParams) ? [] : chatGPTModelListParams;
    const model = chatGPTModelList?.find(item => item?.id === modelId?.toLowerCase());
    return model?.status === Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT;
};

export const handleAddNew = (modelSettingAddList, setModelSettingAddList) => {
    let newModelSettingData = {
        id: uuidv4(),
        model: '',
        systemPrompt: {
            value: '',
            error: '',
            linkPrompt: '',
            isPromptValid: true
        },
        interatorSystemPrompt: {
            value: '',
            error: '',
            linkPrompt: '',
            isPromptValid: true
        },
        isEdit: '',
        isAddNew: true,
    };

    setModelSettingAddList(prev => ([
        newModelSettingData,
        ...prev
    ]));
};

export const editModelSetting = async (index, model, args) => {
    let modelSettingListClone = [...args.modelSettingList];

    if (modelSettingListClone[index].editing !== 1) {
        modelSettingListClone[index].editing = 1;
    }
    args.setIsEdited(true);
    args.setModelSettingList([...modelSettingListClone]);
};
